import React from "react";
import "./GlobalImpactSection.css";
//import { FaGlobe, FaCity } from "react-icons/fa";
import bigben from '../assets/images/biggen.jpeg';
import singaporegardens from '../assets/images/singaporegardens.jpeg'
import towerbridge from '../assets/images/towerbridge.jpeg'
import americanskyline from '../assets/images/americanskyline.jpeg'

import { motion } from "framer-motion";

const GlobalImpactSection = () => {
  return (
    <motion.section
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        >
    <section className="global-impact-section">
      <div className="global-impact-container">
        {/* 左侧大图 + 文案 */}
        <div className="hero-image-wrapper">
          <img
            src={bigben}
            alt="London Big Ben"
            className="hero-image"
          />
          <div className="overlay-text">
            <p className="location">London</p>
            <h2>TfL Go App · Metropolitan Police</h2>
            <button className="view-more-btn">
              View More →
            </button>
          </div>
        </div>

        <div className="content-wrapper-global">
          <h1 className="main-title-global">Global Impact</h1>
          <p className="subtitle">
            Proven across <strong>Europe</strong>, <strong>Asia</strong>, and <strong>North America</strong> — empowering cities, agencies, and industries with predictive intelligence.
          </p>

          <div className="image-grid">
            <div className="image-item">
              <img
                src={singaporegardens}
                alt="Singapore Gardens by the Bay"
              />
            </div>
            <div className="image-item">
              <img
                src={towerbridge}
                alt="London Tower Bridge"
              />
            </div>
            <div className="image-item">
              <img
                src={americanskyline}
                alt="North American City Skyline"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    </motion.section>
  );
};

export default GlobalImpactSection;